import React from 'react';

import { SubtractAlt } from '@carbon/icons-react';

import IconButton from 'components/Buttons/IconButton/IconButton';
import EllipsisText from 'components/EllipsisText/EllipsisText';

import block from 'utils/bem-css-modules';

import style from './RemovableFilterCard.module.pcss';

const b = block(style);

interface RemovableFilterCardProps {
  children: React.ReactNode;
  onRemoveItem: () => void;
  headerText?: string;
}

const RemovableFilterCard: React.FC<RemovableFilterCardProps> = ({ children, headerText, onRemoveItem }) => {
  return (
    <div className={b('cardContainer')}>
      <div className={b('cardContainerHeader', { iconOnly: !headerText })}>
        {headerText && <EllipsisText className={b('title')} text={headerText} />}
        <IconButton onClick={() => onRemoveItem()} type="button" icon={<SubtractAlt />} testId="remove-button" />
      </div>

      <div className={b('itemContainer')}>{children}</div>
    </div>
  );
};

export default RemovableFilterCard;
